import { render, staticRenderFns } from "./RuleGroups.vue?vue&type=template&id=339089a5&"
import script from "./RuleGroups.vue?vue&type=script&lang=js&"
export * from "./RuleGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports